module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Thin-Hestia.5797866.otf";